import React from "react";
import { Box } from "@mui/material";
import ActivityCard from "./ActivityCard";

export default function ActivityPanel({ workflowStep, nextAction, busy, children }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "flex-start",
        gap: 3,
        width: "100%",
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
      <Box
        sx={{
          width: { xs: "100%", md: 320 },
          minWidth: { xs: "100%", md: 320 },
          position: { xs: "static", md: "sticky" },
          top: { md: 100 },
          alignSelf: { md: "flex-start" },
          zIndex: { md: 1 },
        }}
      >
        <ActivityCard
          workflowStep={workflowStep}
          nextAction={nextAction}
          busy={busy}
        />
      </Box>
    </Box>
  );
}
